const ITEMS = [
  "PERSONAL LOANS",
  "AUTO FINANCING",
  "BUSINESS CAPITAL",
  "DEBT CONSOLIDATION",
  "INSTANT DECISIONS",
  "ZERO HIDDEN FEES",
];

const Row = ({ dark }) => (
  <div className="flex shrink-0 items-center">
    {ITEMS.map((item, i) => (
      <span key={i} className="flex items-center">
        <span
          className={`font-display text-2xl md:text-4xl font-bold tracking-tight px-6 md:px-10 whitespace-nowrap ${
            (i + (dark ? 1 : 0)) % 2 === 0 ? "text-[#0A1628]" : "text-outline"
          }`}
        >
          {item}
        </span>
        <svg viewBox="0 0 24 24" className="w-4 h-4 text-[#14D8A5] shrink-0" fill="currentColor" aria-hidden="true">
          <path d="M12 0l2.6 9.4L24 12l-9.4 2.6L12 24l-2.6-9.4L0 12l9.4-2.6z" />
        </svg>
      </span>
    ))}
  </div>
);

const Marquee = () => (
  <section data-testid="marquee" className="relative border-y border-black/5 bg-white/70 py-6 md:py-8 overflow-hidden">
    <div className="marquee-track flex w-max">
      <Row />
      <Row dark />
    </div>
  </section>
);

export default Marquee;
